import { Article } from "./article";
import { PricingItem } from '../../../../index'

export class ConsumablePricingItem extends PricingItem {

    public consumable?: Article;
    public consumableExtraPrice?: string;
    public oldConsumableExtraPrice?: string;
    public consoType: string;

}
